import { useContext, useEffect, useState } from "react";
import Eventos from "../../page/eventos/Eventos";
import { useNavigate, useParams } from "react-router-dom";
import { format } from "date-fns";
import apiAntesala from "../../../config/ConfigPublic";
import apiPrivateAntesala from "../../../config/ConfigPrivate";
import { authContext } from "../../../../context/auth/AuthContext";

const EventosController = () => {
  const { search } = useParams();
  const navigate = useNavigate();
    const { user } = useContext(authContext);
    const { data } = user;
  const [filter, setFilter] = useState({
    ["filter[provincia]"]: "Córdoba",
    //["filter[fecha]"]: format(new Date(), "yyyy-M-dd").toString(), //FullMonth(new Date()),
    sort: "-id",
    per_page: 50,
  });
  const [salas, setSalas] = useState(null);
  const [provincias, setProvincias] = useState(null);
  const [categorias, setCategorias] = useState(null);
  const [eventos, setEventos] = useState(null);
  let controller;

  const onClick = (e, value) => {
    switch (e.target.name) {
      case "añadir-evento":
        {
          return navigate('/dashboard/eventos/nuevo');
        }
        break;
      case "editar-evento" : {
        return navigate("/dashboard/eventos/"+value);
      } break;
    }
  };

  const onChange = async (e, value) => {
    switch (e.target.name) {
      case "search":
        {
          if (controller) controller.abort();

          controller = new AbortController();
          const signal = AbortController.signal;

          let params = {
            ...filter,
            ["filter[nombre]"]: e.target.value,
          };

          setFilter({ ...params });

          return fetch(setEventos, params, "/eventos", signal);
        }
        break;
      case "": {

      }break;
    }
  };

  const fetch = async (setData, params, url, signal) => {
    const response = await apiPrivateAntesala.get(url, { params, signal  });
    if (response.status == 201 || response.status == 200) {
      setData(response.data);
    }
  };

  useEffect(() => {
    if (!eventos) {
      let params = {
        ...filter,
      };

      if (search) {
        params = {
          ...filter,
          ["filter[nombre]"]: search,
        };

        setFilter({ ...params });
      }

      return fetch(setEventos, params, "/eventos");
    }
  }, []);

  useEffect(() => {
    if (!salas) {
      return fetch(setSalas, {["filter[provincia]"]: "Córdoba"}, "/salas");
    }
  }, []);

  useEffect(() => {
    if (!provincias) {
      return fetch(setProvincias, {}, "/provincias");
    }
  }, []);

  useEffect(() => {
    if (!categorias) {
      return fetch(setCategorias, {}, "/categorias");
    }
  }, []);

  
  return (
    <Eventos
      filter={filter}
      setFilter={setFilter}
      fetch={fetch}
      salas={salas ?? { data: [] }}
      provincias={provincias ?? []}
      categorias={categorias ?? []}
      data={eventos ?? { data: [], links: [] }}
      setData={setEventos}
      onChange={onChange}
      onClick={onClick}
      setSalas={setSalas}
      navigate={navigate}
      user={data}
    />
  );
};

export default EventosController;
